import Splide from '@splidejs/splide';

let carousels = document.querySelectorAll('.splide');
carousels = Array.prototype.slice.call(carousels);

carousels.map(elem => {
	const splide = new Splide( elem, {
		type: 'loop',
		// pagination: true,
		autoHeight: true,
		arrows: false,
		autoplay: true
	});

	splide.mount();

	splide.on( 'click', function () {
		splide.go( '>' );
	});
});
